module.exports = __webpack_public_path__ + "static/img/4.ef15083.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/quienes-somos/4.jpg
// module id = t7D0
// module chunks = 0